/** ----------------------------------------
     State
 ---------------------------------------- */

const state = () => {
    return {
        list: {}, // { 1: {}, 2: {}}
    }
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default state;